import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { productCatalog } from '../../data/products/shared';
export function SidebarProductCard({
  productKey
}: {
  productKey: string;
}) {
  const product = productCatalog[productKey];
  if (!product) return null;
  const Icon = product.icon;
  return <div className="rounded-[14px] border border-canvas-line bg-white p-5" data-id="element-172" data-mp="1g1ru3qhnytey">
      <span className="flex h-10 w-10 items-center justify-center rounded-[10px] bg-brand-soft text-brand" data-id="element-173" data-mp="jd293raqpkor">
        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-174" data-mp="obwsovgj7d9x" />
      </span>
      <p className="mt-4 text-[16px] font-semibold leading-[1.35] text-ink" data-id="element-175" data-mp="sc79721y9m31">
        {productKey === 'inventory' ? 'Track stock automatically with Kayko Inventory' : `Try Kayko ${product.title}`}
      </p>
      <p className="mt-2 text-[14px] leading-[1.55] text-ink-muted" data-id="element-176" data-mp="23snfo5vj0sdr">{product.copy}</p>
      <SmartLink href={product.href} className="group mt-4 inline-flex items-center gap-1.5 text-[14px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-177" data-mp="28qoz4rwv6tpr">
        Learn more
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-178" data-mp="2vh7ruxfwf62g" />
      </SmartLink>
    </div>;
}